/* 12 Bar — Homepage V2. Progressive enhancement only: everything works without JS. */
(function () {
  if (window.__tbV2) return;
  window.__tbV2 = true;
  document.documentElement.classList.add('tb-anim');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tb-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Add to basket: AJAX into the theme's existing cart drawer; falls back to normal form POST */
  function initAddToCart(root) {
    (root || document).querySelectorAll('form.tb-addform').forEach(function (form) {
      if (form.__tb) return;
      form.__tb = true;
      form.addEventListener('submit', function (evt) {
        if (!window.fetch || !document.getElementById('Cart-Drawer')) return; // let the form post to /cart
        evt.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        var root = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
        fetch(root + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json && (res.json.description || res.json.message) || 'Error');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (btn) { btn.classList.add('is-added'); }
            var toggle = document.getElementById('cart-drawer-toggle');
            setTimeout(function () { if (toggle) toggle.click(); }, 350);
          })
          .catch(function (err) {
            var msg = form.querySelector('[data-tb-msg]');
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
          })
          .finally(function () {
            if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
            setTimeout(function () { if (btn) { btn.classList.remove('is-added'); btn.textContent = label; } }, 2400);
          });
      });
    });
  }

  /* Mobile sticky actions: show after the hero, hide over the newsletter/footer */
  function initMobileBar() {
    var bar = document.querySelector('[data-tb-mbar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('.tb-hero');
    var stops = document.querySelectorAll('.tb-dig, .footer, #shopify-section-footer, footer');
    var pastHero = !hero, overStop = false;
    function update() { var on = pastHero && !overStop; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', String(!on)); bar.inert = !on; }
    if (hero) {
      new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; update(); }, { threshold: 0, rootMargin: '-40% 0px 0px 0px' }).observe(hero);
    }
    var visibleStops = new Set();
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? visibleStops.add(e.target) : visibleStops.delete(e.target); });
      overStop = visibleStops.size > 0; update();
    });
    stops.forEach(function (s) { so.observe(s); });
    update();
  }

  function init(root) { initReveal(root); initAddToCart(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initMobileBar(); });
  } else { init(); initMobileBar(); }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('[data-tb-mbar]')) initMobileBar(); });
})();
